/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { HttpService } from '@angular-kit/core';
import { TimeRecord, TimeRecordData } from '@teamworks/global';
import { HostInfo, HostInfoData } from '@typescript-kit/core';

@Injectable()
export class TimeClockService {

  constructor(private httpService: HttpService) { }

  async loadHostInfo(): Promise<HostInfo> {
    return this.httpService.get(`api/server/host-info`)
      .then((hostInfoData: HostInfoData) => new HostInfo(hostInfoData));
  }

  async start(timeClockId: string, companyId: string, employeeId: string): Promise<TimeRecord[]> {
    const encodedTimeClockId = encodeURIComponent(timeClockId);
    const encodedCompanyId = encodeURIComponent(companyId);
    const encodedEmployeeId = encodeURIComponent(employeeId);
    // const encodedTime = encodeURIComponent(moment().toISOString(true));
    return this.httpService.post(`api/time-clock/start/${encodedTimeClockId}/${encodedCompanyId}/${encodedEmployeeId}`)
      .then((timeRecordList: TimeRecordData[]) => timeRecordList.map((data) => new TimeRecord(data)));
  }

  async stop(timeClockId: string, companyId: string, employeeId: string): Promise<TimeRecord[]> {
    const encodedTimeClockId = encodeURIComponent(timeClockId);
    const encodedCompanyId = encodeURIComponent(companyId);
    const encodedEmployeeId = encodeURIComponent(employeeId);
    // const encodedTime = encodeURIComponent(moment().toISOString(true));
    return this.httpService.post(`api/time-clock/stop/${encodedTimeClockId}/${encodedCompanyId}/${encodedEmployeeId}`)
      .then((timeRecordList: TimeRecordData[]) => timeRecordList.map((data) => new TimeRecord(data)));
  }

}
